import axios from "axios";
import { getHeaders, checkStatus } from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;


export async function getReqSalarySlip(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/ReqSalarySlip`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function getAllSalarySlip(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/GetAllSalarySlip`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function getArrearList(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Arrear/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function postArrearUpdate(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Arrear/AddUpdate`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function postArrearDelete(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Arrear/Delete`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}
export async function getIncentiveList(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Incentive/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function postIncentiveAddUpdate(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Incentive/AddUpdate`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function postIncentiveDelete(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Incentive/Delete`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function getReimbursementList(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Reimbursement/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function postReimbursementAddUpdate(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Reimbursement/AddUpdate`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function postReimbursementDelete(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Reimbursement/Delete`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}





export async function getLoanList(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Loan/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function postLoanAddUpdate(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Loan/AddUpdate`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function postLoanDelete(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Loan/Delete`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function getTaxList(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Tax/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

export async function GetSalaryRegister(params){
   try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Salary/Register`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getSalarySlip(params){
  try {
    const response = await axiosInstance.post(`${baseURL}/Payroll/Pay/Slip`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}

